import script from "./SurveySection.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveySection.vue?vue&type=script&setup=true&lang=js"

import "./SurveySection.vue?vue&type=style&index=0&id=9fb80b3a&scoped=true&lang=css"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fb80b3a"]])

export default __exports__